import { render, staticRenderFns } from "./MediaThumbnail.vue?vue&type=template&id=1bd77970&scoped=true&"
import script from "./MediaThumbnail.vue?vue&type=script&lang=ts&"
export * from "./MediaThumbnail.vue?vue&type=script&lang=ts&"
import style0 from "./MediaThumbnail.vue?vue&type=style&index=0&id=1bd77970&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd77970",
  null
  
)

export default component.exports